(function () {

	const cDropBox = () => {
		const dropbox = document.querySelectorAll('.c-dropbox');
		const dropBtn = document.querySelectorAll('.c-dropbox__btn');
		if(dropBtn) {
			dropBtn.forEach(btn => {
				const dropbox = btn.closest('.c-dropbox');
				btn.addEventListener('click', () => {
					dropbox.classList.toggle('c-dropbox--active');
				})
			})
		}
		document.addEventListener('click', (e) => {
			dropbox.forEach(box => {
				if(box.classList.contains('c-dropbox--active') && !box.contains(e.target)) {
					box.classList.remove('c-dropbox--active');
				}
			})
		})
	}

	document.addEventListener('shopify:section:load', cDropBox);
	cDropBox();

})();